import { useMutation, useQueryClient } from "@tanstack/vue-query";
import BucketLock from "@/services/bucket/bucket-lock";

export function useDeleteBucketLockOverride() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await BucketLock.deleteBucketLockOverride(id);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete bucket lock override");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bucketLockOverrides"] });
      queryClient.invalidateQueries({ queryKey: ["bucketLockStatus"] });
    },
  });
}
